import Josh from 'joshjs';

//Navbar Toggler
document.addEventListener('DOMContentLoaded', function () {
  var navbarTogglers = document.querySelectorAll('.navbar-toggler');
  var navbarContent = document.querySelector('.navbar-content');

  navbarTogglers.forEach(function (toggler) {
    toggler.addEventListener('click', function () {
      this.classList.toggle('active');
      navbarContent.classList.toggle('active');
    });
  });
});

//Joshjs '/ Animate
const josh = new Josh({
  // DOM CSS class to Animate, default is "josh-js"
  initClass: "josh-js",

  // Animation CSS class from Animate.css library
  animClass: "animate__animated",

  // Element distance of viewport to triggering the animation. default is 0.2 means 20% of element view animation will trigger
  offset: 0.2,

  // Animation will trigger on Mobile or not. Default is true
  animateInMobile: true,

  // Animation will trigger on newly added element or not. Default is false
  onDOMChange: false,
});


//Archive - Filter
document.addEventListener('DOMContentLoaded', function () {
  var archiveFilterBtns = document.querySelectorAll('.section--archive-filter .btn');
  var listingPosts = document.querySelectorAll('.listing-post');

  archiveFilterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      archiveFilterBtns.forEach(function (otherBtn) {
        otherBtn.classList.remove('btn-primary');
        otherBtn.classList.add('btn-outline-primary');
      });

      this.classList.remove('btn-outline-primary');
      this.classList.add('btn-primary');

      var btnCategory = this.getAttribute('data-category');

      listingPosts.forEach(function (post) {
        var postCategories = post.getAttribute('data-category').split(' ');

        if (postCategories.includes(btnCategory)) {
          post.classList.remove('d-none');
          post.classList.add('d-block');
        } else {
          post.classList.remove('d-block');
          post.classList.add('d-none');
        }
      });
    });
  });

  var arrowBtn = document.querySelector('.section--archive-filter .btn-arrow');

  if (arrowBtn) {
    arrowBtn.addEventListener('click', function () {
      archiveFilterBtns.forEach(function (btn) {
        btn.classList.remove('btn-primary');
        btn.classList.add('btn-outline-primary');
      });

      listingPosts.forEach(function (post) {
        post.classList.remove('d-none');
        post.classList.add('d-block');
      });
    });
  }

});

//Fancybox
import { Fancybox } from '@fancyapps/ui'

document.addEventListener('DOMContentLoaded', function () {
  Fancybox.bind('[data-fancybox]', {})
});

//Slick Slider
import { slick } from 'slick-carousel';

//Iframe on Modal
let modal = document.getElementById('video-modal');

if (modal) {
  let iframe = modal.querySelector('iframe');

  if (iframe) {
    let attrib = iframe.getAttribute('src');
    let urlsrc = new URL(attrib);

    modal.addEventListener('show.bs.modal', () => {
      urlsrc.searchParams.set('autoplay', 'true');
      iframe.setAttribute('src', urlsrc.toString());
    })

    modal.addEventListener('hidden.bs.modal', () => {
      urlsrc.searchParams.set('autoplay', 'false');
      iframe.setAttribute('src', '');
    })

  }
}